import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getListBranchMetForActionLog } from 'flow-doctor-lib/utils/listBranchEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const BranchMetLabel = ({
  logEvent
}) => {
  const branchName = getListBranchMetForActionLog(logEvent);
  return branchName ? /*#__PURE__*/_jsx("span", {
    children: branchName
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "flow-doctor-lib.flows.listBranchDebugPanel.noneMet"
  });
};
export default BranchMetLabel;